// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"2727ad63","436":"cbd516bc","591":"8e003e9e","662":"cbd516bc","821":"4fc823d0"}[chunkId] + ".chunk.css";
};